import React from "react";
import './style/more.css';

const Banner = () => {
  return (
    <div className='main'>
        <div className='container'>
            <div className='bike-container'>
                <div className='bg-color'>
                    <div className='bike'>
                        <img src={require(`../assets/duke.png`)} alt='' />
                    </div>
                    <div className='details'>
                    <i>
                    <h2>PROJECT MADE BY STUDENTS OF ASANSOL ENGINEERING COLLEGE
                    ASANSOL,WEST BENGAL Batch- 2022 PASSOUT DEPARTMENT INFORMATION TECHNOLOGY</h2>
                        </i>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Banner;